<script>
import headBanner from './head';
import carSeries from './carSeries';
import activityform from './form';
import promotion from './promotion';
import autoShow from './autoShow';
import information from './information';

import footerBtn from './footer';
import loading from '@/components/loading';
import store from './store/index.js';
export default {
    name: 'mainApp',
    data() {
        return {
            load: !window.__PRERENDER_INJECTED,
            cityName: '',
            cityId: ''
        };
    },
    components: {
        headBanner,
        carSeries,
        activityform,
        promotion,
        autoShow,
        information,
        footerBtn,
        loading
    },
    computed: {
        isLoadingShow() {
            return store.loading.show;
        },
        loadingText() {
            return store.loading.text;
        }
    }
}
</script>

<template>
    <div id="app">
        <head-banner></head-banner>
        <div class="bgWrap">
            <car-series></car-series>
            <activityform></activityform>
            <promotion v-if="load"></promotion>
            <!-- <auto-show></auto-show> -->
            <information v-if="load"></information>
        </div>
        <footer-btn></footer-btn>
        <loading :status="isLoadingShow" :text="loadingText"></loading>
    </div>
</template>

<style lang="stylus" scoped>
#app
    overflow hidden
    background-color #35008B
    .bgWrap
        background: url('../assets/bg.png');
        background-size: 20rem auto;
</style>
